import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { SolicitarAyuda } from './pages/SolicitarAyuda';
import { QuieroSerAliado } from './pages/QuieroSerAliado';
import { Donar } from './pages/Donar';
import { VenezuelaEmergencia } from './pages/VenezuelaEmergencia';
import { DonarVenezuela } from './pages/DonarVenezuela';
import { Tienda } from './pages/Tienda';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mndna7xolord">
      <div className="w-full min-h-screen bg-white" data-id="element-1" data-mp="2mjzm330r7lli">
        <Navbar data-id="element-2" data-mp="31bs09botatln" />
        <Routes data-id="element-3" data-mp="31c9tdzg6grpc">
          <Route path="/" element={<Home data-id="element-5" data-mp="2wk06yte9u9rt" />} data-id="element-4" data-mp="31ctfztgrw49p" />
          <Route path="/solicitar-ayuda" element={<SolicitarAyuda data-id="element-7" data-mp="2wip5j08ate3v" />} data-id="element-6" data-mp="2wjqhd6x524mn" />
          <Route path="/quiero-ser-aliado" element={<QuieroSerAliado data-id="element-9" data-mp="28te37ebavbnm" />} data-id="element-8" data-mp="28ufnm9e7hai0" />
          <Route path="/donar" element={<Donar data-id="element-11" data-mp="23vkw8j26adma" />} data-id="element-10" data-mp="28sbb5328r364" />
          <Route path="/venezuela-emergencia" element={<VenezuelaEmergencia data-id="element-13" data-mp="3ijxnsm94vshs" />} data-id="element-12" data-mp="23w4drynwuzzs" />
          <Route path="/donar-venezuela" element={<DonarVenezuela data-id="element-15" data-mp="3ii4sg33z0up3" />} data-id="element-14" data-mp="3ij64a9st9l7v" />
          <Route path="/tienda" element={<Tienda data-id="element-17" data-mp="3mk84asujy1aw" />} data-id="element-16" data-mp="3ml12v6jcxkhy" />
        </Routes>
        <Footer data-id="element-18" data-mp="3mj6jhwnqi0fz" />
      </div>
    </BrowserRouter>;
}